export default __webpack_public_path__ + "static/media/jashon.45543d0f.jpg";